import { useEffect, useState } from "react";
import { Combobox, ETypeOfNotification, getDate, InputDate, InputTextCustom, Loader, setNotification } from "medere-ui-framework";
import React from "react";
import { PersonalData } from "../../../../dto/profiledata/ProfileDataFormDTO";
import { loadDocumentTypes, loadPersonalPhoto, loadSignature, uploadPersonalPhoto, uploadSignature } from "../../../../servicesHooks/ProfileDataForm/useProfileDataFormService";
import { ComboDataDTO } from "../../../../dto/ComboDataDTO";
import imageCompression from 'browser-image-compression';
import { useDispatch } from "react-redux";
import CityLocationCombo from "../../../../components/CityLocationCombo";


interface PersonalTabProps {
    personalData:PersonalData
    setPersonalData: (personalData: PersonalData) => void;
    isProfessional: boolean;
    errors: Partial<Record<keyof PersonalData, boolean>>;
}

const imageCompressionOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
};

export default function PersonalTab({personalData, setPersonalData, isProfessional, errors}:PersonalTabProps) {

    const dispatch = useDispatch();

    const [previousPhoto, setPreviousPhoto] = useState<string | null>(null);

    const [newPhoto, setNewPhoto] = useState<string | null>(null);

    const [loadingPhoto, setLoadingPhoto] = useState<boolean>(false);

    //Cargo inicialmente las fotos de perfil y firma
    useEffect(() => {
        if(!isProfessional) return;
        loadPersonalPhoto().then((response) => {setPreviousPhoto(response);}).catch((error) => {console.error(error);});
    }, [isProfessional]);
    
    // TODO agregar errors
    const ERROR_MESSAGE = 'Este campo es necesario para continuar';

    const genderOptions = [
        { id: 'M', name: 'Masculino' },
        { id: 'F', name: 'Femenino' }
    ];


    return <React.Fragment>
        <div className='grid-container' style={{ width: '100%' }}>
            <div className='grid-row two-columns'>
                <InputTextCustom
                    className={!(errors.firstname) ? `white-component` : `blank-error-component`} 
                    spanClassName="combobox-border"
                    name="firstname"
                    value={personalData.firstname}
                    onChange={(e:any) => {
                        if(e == null) return;
                        setPersonalData({ ...personalData, firstname: e.target.value })
                    }}
                    label='Nombre' 
                    required
                />
                <InputTextCustom
                    className={!(errors.lastname) ? `white-component` : `blank-error-component`} 
                    spanClassName="border2"
                    name="lastname"
                    value={personalData.lastname}
                    onChange={(e:any) => {
                        if(e == null) return;
                        setPersonalData({ ...personalData, lastname: e.target.value })
                    }}
                    label='Apellido'
                    required 
                />
            </div>
            <div className='grid-row four-columns'>
                <Combobox
                    className={!(errors.documenttype) ? `white-component` : `blank-error-component`} 
                    label='Tipo de documento'
                    placeholder='Seleccionar'
                    autocompleteClassName="combobox-border"
                    getItems={loadDocumentTypes}
                    optionLabel='shortName'
                    value={personalData.documenttype?.name}
                    setValue={(documentType:any) => {
                        if(documentType == null) return;
                        setPersonalData({ ...personalData, documenttype: {id : documentType.documentType, name : documentType.shortName} })
                    }}
                    required
                />
                <InputTextCustom
                    className={!(errors.document) ? `white-component` : `blank-error-component`} 
                    spanClassName="border2"
                    name="document"
                    value={personalData.document}
                    onChange={(e:any) => {
                        if(e == null) return;
                        setPersonalData({ ...personalData, document: e.target.value })
                    }}
                    label='N° de documento' 
                    required
                />
                <Combobox
                    className={!(errors.gender) ? `white-component` : `blank-error-component`} 
                    label='Sexo'
                    placeholder='Seleccionar'
                    autocompleteClassName="combobox-border"
                    getItems={() => Promise.resolve(genderOptions)}
                    optionLabel="name"
                    value={genderOptions.find((option) => option.id == personalData.gender)}
                    setValue={(gender:ComboDataDTO) => {
                        if(gender == null) return;
                        setPersonalData({ ...personalData, gender: String(gender.id) })
                    } } 
                    required
                />
                <InputDate
                    className={!(errors.birthdate) ? `white-component` : `blank-error-component`} 
                    label='Fecha de nacimiento'
                    value={getDate(personalData.birthdate)}
                    onChange={(e) => setPersonalData({ ...personalData, birthdate: e.value })} 
                    calendarClassName="border2Date"
                    required
                />
            </div>
            <div className='grid-row two-columns'>
                <InputTextCustom 
                    spanClassName="border2" 
                    label='Dirección' 
                    name="address" 
                    value={personalData.address} 
                    onChange={(e) => setPersonalData({ ...personalData, address: e.target.value })} 
                />
                <CityLocationCombo
                    className={!errors.city ? 'white-component' : 'blank-error-component'}
                    label="Ciudad"
                    value={personalData.city}
                    onChange={(city: ComboDataDTO | null) => {
                        if (city == null) return;
                        setPersonalData({ ...personalData, city, isCityExternalId: true });
                    }}
                    error={!!errors.city}
                    required
                />

            </div>
            <div className='grid-row two-columns'>
                <InputTextCustom
                    className={!(errors.mobilephone) ? `white-component` : `blank-error-component`} 
                    spanClassName="combobox-border"
                    name="mobilephone"
                    value={personalData.mobilephone}
                    onChange={(e) => {
                        if(e == null) return; 
                        setPersonalData({ ...personalData, mobilephone: e.target.value })
                    }}
                    label={!isProfessional ? "Celular corporativo" : "Celular"} 
                    required
                />
                <InputTextCustom
                    className={!(errors.email) ? `white-component` : `blank-error-component`} 
                    spanClassName="combobox-border"
                    name="email"
                    value={personalData.email}
                    onChange={(e) => {
                        if(e == null) return;
                        setPersonalData({ ...personalData, email: e.target.value })
                    }}
                    label={!isProfessional ? "Mail corporativo" : "Mail"}
                    required 
                />
            </div>
            {isProfessional && (
                <div className="file-upload-container">
                    <label className="file-label">Foto personal</label>
                    <div className="file-upload" onClick={() => document.getElementById('photoInput').click()}>
                    <button className="upload-button">
                        Tomar o cargar <span className="bold">una foto de perfil</span>
                    </button>
                    <input
                        id="photoInput"
                        type="file"
                        accept="image/*"
                        onChange={async (event) => {
                        const file = event.target.files[0];
                        if (!file) return;
                        setLoadingPhoto(true);
                        try {
                            const compressedFile = await imageCompression(file, imageCompressionOptions);
                            if (compressedFile.size < 1048576) {
                            uploadPersonalPhoto(compressedFile).then(() => {
                                setNewPhoto(URL.createObjectURL(compressedFile));
                                dispatch(setNotification({
                                title: "Foto actualizada correctamente",
                                icon: 'pi-check',
                                typeOfNotification: ETypeOfNotification.INFO
                                }));
                            }).catch((error) => {
                                console.error(error);
                            });
                            } else {
                            dispatch(setNotification({
                                title: "No pudimos cargar la foto",
                                desc: "Te pedimos por favor que selecciones una imagen de tamaño menor a 1MB",
                                icon: 'pi-times',
                                typeOfNotification: ETypeOfNotification.ERROR
                            }));
                            }
                        } catch (error) {
                            console.error('Error al comprimir la imagen:', error);
                        }
                        setLoadingPhoto(false);
                        }}
                        style={{ display: 'none' }}
                    />
                    {loadingPhoto ? (
                        <Loader />
                    ) : (
                        (newPhoto || previousPhoto) && (
                        <img src={newPhoto ?? previousPhoto} alt="Foto personal" className="preview-image" />
                        )
                    )}
                    </div>
                </div>
            )}
        </div>
     </React.Fragment>;
}
